module.exports = __webpack_public_path__ + "static/img/banner1.063739d.jpg";